<template>
    <div class="com-codics-hbb-order-admin-user-info-body">
        <div class="com-codics-hbb-order-admin-user-info-bar-content">
            <div class="com-codics-hbb-order-admin-user-info-bar-tag-box">
                <div class="com-codics-hbb-order-admin-user-info-bar-tag-item" v-for="(item, index) in tagData"
                    :style="{ '--nowIndex': nowIndex == index ? 'visible' : 'hidden' }" :key="index">
                    {{ item }}
                </div>
            </div>
            <div class="com-codics-hbb-order-admin-user-info-content">
                <div class="com-codics-hbb-order-admin-user-info-himg-box">
                    <div class="com-codics-hbb-order-admin-user-info-himg">
                        <img :src="userInfo?.user?.himg == '' ? 'https://cube.elemecdn.com/3/7c/3ea6beec64369c2642b92c6726f1epng.png' : 'https://cdn.bosscaigou.com/' + userInfo?.user?.himg"
                            alt="个人头像">
                    </div>
                    <div class="com-codics-hbb-order-admin-user-info-himg-line"></div>
                    <div
                        class="com-codics-hbb-order-admin-user-info-himg-line com-codics-hbb-order-admin-user-info-himg-line2">
                    </div>
                    <div
                        class="com-codics-hbb-order-admin-user-info-himg-line com-codics-hbb-order-admin-user-info-himg-line3">
                    </div>
                    <div
                        class="com-codics-hbb-order-admin-user-info-himg-line com-codics-hbb-order-admin-user-info-himg-line4">
                    </div>
                    <div class="com-codics-hbb-order-admin-user-info-himg-text">个人头像</div>
                </div>
                <div class="com-codics-hbb-order-admin-user-info-line">
                    <div class="com-codics-hbb-order-admin-user-info-line-text"><span
                            style="color: #798597;">姓名：</span>{{ userInfo?.user?.nickname }}</div>
                    <div class="com-codics-hbb-order-admin-user-info-line-text"><span
                            style="color: #798597;">部门：</span><span style="color: #2E2F44;">{{
                    '超级管理员' }}</span></div>
                    <div class="com-codics-hbb-order-admin-user-info-line-text"><span
                            style="color: #798597;">电话：</span><span style="color: #2E2F44;">{{
                    '13155553831' }}</span></div>
                    <div class="com-codics-hbb-order-admin-user-info-line-text"><span
                            style="color: #798597;">邮箱：</span><span style="color: #2E2F44;">{{
                    '3041913305@qq.com' }}</span></div>
                </div>
                <div
                    class="com-codics-hbb-order-admin-user-info-himg-box com-codics-hbb-order-admin-user-info-himg-box2">
                    <div class="com-codics-hbb-order-admin-user-info-himg">
                        <img :src="'https://cdn.bosscaigou.com/huayuan/img/%E4%BA%8C%E7%BB%B4%E7%A0%81.png'"
                            alt="绑定微信二维码">
                    </div>
                    <div class="com-codics-hbb-order-admin-user-info-himg-line"></div>
                    <div
                        class="com-codics-hbb-order-admin-user-info-himg-line com-codics-hbb-order-admin-user-info-himg-line2">
                    </div>
                    <div
                        class="com-codics-hbb-order-admin-user-info-himg-line com-codics-hbb-order-admin-user-info-himg-line3">
                    </div>
                    <div
                        class="com-codics-hbb-order-admin-user-info-himg-line com-codics-hbb-order-admin-user-info-himg-line4">
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { mapState } from 'vuex';
import dayjs from 'dayjs';
import MyButton from '@/components/MyButton';
import MyDialog from '@/components/MyDialog';
import { addRole, deleteRoles, updateRole, listRole } from '@/api';
export default {
    data() {
        return {
            nowIndex: 0,
            tagData: ['用户信息']
        }
    },
    components: {
        MyButton,
        MyDialog
    },
    mounted() {


    },
    computed: {
        ...mapState(['userInfo'])
    },
    methods: {
    }
}
</script>

<style>
.com-codics-hbb-order-admin-user-info-body {
    height: fit-content;
    min-height: 100%;
    width: 100%;
    position: relative;
    float: left;
    box-sizing: border-box;
    padding: 10px;
}

:root {
    --hbb-user-info-bar-l-color: #EEE;
}

:root[data-theme="dark"] {}

.com-codics-hbb-order-admin-user-info-bar-content {
    height: fit-content;
    width: 100%;
    position: relative;
    float: left;
    box-sizing: border-box;
    background: var(--sbar-bg-color);
    border-radius: 6px;
    border: 1px solid var(--sbar-l-3-color);
    padding: 0 15px;
    transition: .3s;
}

.com-codics-hbb-order-admin-user-info-bar-tag-box {
    height: 40px;
    width: 100%;
    position: relative;
    float: left;
    line-height: 40px;
    box-sizing: border-box;
    border-bottom: 1px solid var(--hbb-user-info-bar-l-color);
}

/* .com-codics-hbb-order-admin-user-info-bar-tag-box::before {
    content: "";
    height: 1px;
    width: calc();
    position: absolute;
    left: 0;
    top: 0;
    background: #EEE;
    background: var(--hbb-user-info-bar-l-color);
} */

.com-codics-hbb-order-admin-user-info-bar-tag-item {
    height: 40px;
    width: fit-content;
    position: relative;
    float: left;
    display: flex;
    box-sizing: border-box;
    padding: 0 20px;
    line-height: 40px;
    text-align: center;
    cursor: pointer;
    font-size: 12px;
    color: #333;
    transition: .3s;
    font-weight: bolder;
}

.com-codics-hbb-order-admin-user-info-bar-tag-item::before {
    content: "";
    height: 2px;
    width: calc(100% - 30px);
    position: absolute;
    margin: auto;
    left: 0;
    right: 0;
    bottom: 0;
    background: #333;
    transition: .3s;
    border-radius: 1px;
}

.com-codics-hbb-order-admin-user-info-content {
    height: 205px;
    width: 100%;
    position: relative;
    float: left;
    box-sizing: border-box;
    padding: 15px 10px;
}

.com-codics-hbb-order-admin-user-info-himg {
    height: 100%;
    width: 100%;
    position: relative;
    float: left;
    box-sizing: border-box;
    padding: 20px;
    border: 1px solid #333;
    overflow: hidden;
}

.com-codics-hbb-order-admin-user-info-himg img {
    height: 100%;
    width: 100%;
    position: relative;
    float: left;
    box-sizing: border-box;
}

.com-codics-hbb-order-admin-user-info-himg-text {
    height: 20px;
    width: fit-content;
    position: absolute;
    margin: auto;
    top: 0;
    box-sizing: border-box;
    line-height: 20px;
    font-size: 12px;
    font-weight: bolder;
    color: #333;
    text-align: center;
}

.com-codics-hbb-order-admin-user-info-himg-box {
    height: 100%;
    width: 175px;
    position: relative;
    float: left;
    box-sizing: border-box;
    border-left: 1px solid #DDD;
    padding: 30px;
}

.com-codics-hbb-order-admin-user-info-himg-box::before,
.com-codics-hbb-order-admin-user-info-himg-box::after {
    content: "";
    height: 1px;
    width: 10px;
    position: absolute;
    margin: auto;
    left: -5px;
    top: 0;
    background: #DDD;
}

.com-codics-hbb-order-admin-user-info-himg-box::after {
    top: unset;
    bottom: 0;
}

.com-codics-hbb-order-admin-user-info-himg-box2 {
    border-left: unset !important;
    cursor: pointer;
}

.com-codics-hbb-order-admin-user-info-himg-box2::before,
.com-codics-hbb-order-admin-user-info-himg-box2::after {
    content: '扫描二维码绑定微信';
    height: 30px;
    width: 100%;
    position: absolute;
    margin: auto;
    left: 0;
    right: 0;
    top: -5px;
    line-height: 30px;
    font-size: 12px;
    color: #333;
    background: unset;
    text-align: center;
    font-weight: bolder;
}

.com-codics-hbb-order-admin-user-info-himg-box2::after {
    content: '鼠标点击刷新二维码';
    top: unset;
    bottom: 0px;
    color: #777;
    font-size: 10px;
}

.com-codics-hbb-order-admin-user-info-line {
    height: 100%;
    width: calc(100% - 350px);
    position: relative;
    float: left;
    box-sizing: border-box;
    padding: 7.5px 0px 7.5px 30px;
    border-right: 1px solid #333;
}

.com-codics-hbb-order-admin-user-info-line::before {
    content: '';
    height: calc(100% - 20px);
    width: 1px;
    position: absolute;
    margin: auto;
    right: -1px;
    top: 0;
    bottom: 0;
    background: #EEE;
}

.com-codics-hbb-order-admin-user-info-line-text {
    height: 40px;
    width: 100%;
    position: relative;
    float: left;
    box-sizing: border-box;
    line-height: 40px;
    font-size: 12px;
    color: #333;
    font-weight: bolder;
}

.com-codics-hbb-order-admin-user-info-himg-line {
    height: 1px;
    width: 90px;
    position: absolute;
    margin: auto;
    top: 30px;
    left: 0;
    right: 0;
    background: #EEE;
}

.com-codics-hbb-order-admin-user-info-himg-line2 {
    top: 144px !important;
}

.com-codics-hbb-order-admin-user-info-himg-line3 {
    width: 1px;
    height: 90px;
    right: auto;
    left: 30px;
    top: 0;
    bottom: 0;
}

.com-codics-hbb-order-admin-user-info-himg-line4 {
    width: 1px;
    height: 90px;
    right: 30px;
    left: auto;
    top: 0;
    bottom: 0;
}
</style>